<template>
  <section class="relative w-full custom-scrollbar overflow-x">
    <table class="w-full bg-white table-auto min-w-max">
      <thead class="text-gray-400 bg-white border-b border-gray-200">
        <tr>
          <th class="p-3 text-sm text-left">Title</th>
          <th class="p-3 text-sm text-left">Start Date</th>
          <th class="p-3 text-sm text-left">End Date</th>
          <th class="p-3 text-sm text-left">Assign Employee</th>
          <th class="p-3 text-sm text-left">Created By</th>
          <th class="p-3 text-sm text-left">Task Progress</th>
          <th class="p-3 text-sm text-left">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr lass="border-b" v-for="(task, index) in tasks" :key="index">
          <td class="p-3 text-sm">{{ task.task_name }}</td>
          <td class="p-3 text-sm">
            {{ task.task_date_start }}
          </td>
          <td class="p-3 text-sm">
            {{ task.task_date_end }}
          </td>
          <td class="p-3 text-sm">
            <ul v-for="(task_worker, key) in task.task_workers" :key="key">
              <li>{{ task_worker.emp_fullname }}</li>
            </ul>
          </td>
          <td class="p-3 text-sm">
            {{ task.created_by?.role }}
          </td>
          <td class="p-3 text-sm">
            {{ task.progress }}% Complete
            <div
              v-if="task.progress > 0"
              class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-200"
            >
              <div
                class="bg-blue-600 h-2.5 rounded-full"
                :style="`width: ${task.progress}%`"
              ></div>
            </div>
          </td>
          <td class="relative flex p-3 text-right">
            <Button
              class="mr-3 rounded-full shadow-none hover:bg-blue-100 text-primary"
              @click="$emit('edit', task)"
            >
              <font-awesome-icon icon="fa-pen-to-square" />
            </Button>
            <Button
              class="text-red-500 rounded-full shadow-none hover:bg-red-100"
              @click="$emit('delete', task._id)"
            >
              <font-awesome-icon icon="fa-trash-alt" />
            </Button>
          </td>
        </tr>
      </tbody>
    </table>
    <Pagination
      v-if="tasks.length"
      :current="meta.currentPage"
      :total="meta.total"
      :per-page="limit"
      @page-changed="$emit('on-page-changed', $event)"
    />
  </section>
</template>

<script>
import Pagination from "@ocrv/vue-tailwind-pagination";
import "@ocrv/vue-tailwind-pagination/styles";
import Button from "@/components/Button.vue";

export default {
  name: "TabelTask",
  components: {
    Button,
    Pagination,
  },
  props: {
    tasks: {
      type: Array,
      required: true,
    },
    meta: {
      type: Object,
      required: true,
    },
    limit: {
      type: Number,
      required: true,
    },
  },
};
</script>
